import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4bc1532"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("div", null, "操作提示："),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"5px","font-size":"14px"} }, "订单状态有待付款，待发货，待收货，已完成，已关闭。"),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"5px","font-size":"14px"} }, "待付款订单取消后则为已关闭；待付款订单支付后则为待发货；待发货订单发货后则为待收货；待收货订单收货后则为已完成； ")
], -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("订单ID：")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("订单编号：")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("订单类型：")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("下单时间：")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("订单来源：")
const _hoisted_10 = ["src"]
const _hoisted_11 = { style: {"margin-left":"60px"} }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("店铺名称：")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("商家编号：")
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("运费：")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("商品金额：")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("优惠金额：")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("应付金额：")
const _hoisted_19 = ["src"]
const _hoisted_20 = { style: {"margin-left":"60px"} }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("会员编号：")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("会员昵称：")
const _hoisted_23 = ["src"]
const _hoisted_24 = { style: {"margin-left":"60px"} }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("商品名称：")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("商品数量：")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("商品单价：")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("总价：")
const _hoisted_29 = { key: 5 }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("订单状态：")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("支付状态：")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("支付方式：")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("实付金额：")
const _hoisted_34 = { key: 6 }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("订单详情")
const _hoisted_36 = { id: "printMe" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "基本信息", -1))
const _hoisted_38 = { style: {"border-top":"1px solid #f0f0f0"} }
const _hoisted_39 = { style: {"display":"flex"} }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "订单号", -1))
const _hoisted_41 = { class: "item item2" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "订单状态", -1))
const _hoisted_43 = { class: "item item2" }
const _hoisted_44 = { style: {"display":"flex"} }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "商户", -1))
const _hoisted_46 = { class: "item item2" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "下单时间", -1))
const _hoisted_48 = { class: "item item2" }
const _hoisted_49 = { style: {"display":"flex"} }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "支付方式", -1))
const _hoisted_51 = { class: "item item2" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "付款时间", -1))
const _hoisted_53 = { class: "item item2" }
const _hoisted_54 = { style: {"display":"flex"} }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "配送方式", -1))
const _hoisted_56 = { class: "item item2" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { key: 2 }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "发货时间", -1))
const _hoisted_61 = { class: "item item2" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle",
  style: {"margin-top":"20px"}
}, "收货人信息", -1))
const _hoisted_63 = { style: {"border-top":"1px solid #f0f0f0"} }
const _hoisted_64 = { style: {"display":"flex"} }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "收货人", -1))
const _hoisted_66 = { class: "item item2" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "电话", -1))
const _hoisted_68 = { class: "item item2" }
const _hoisted_69 = { style: {"display":"flex"} }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item item2",
  style: {"width":"25%"}
}, "收货地址", -1))
const _hoisted_71 = {
  class: "item item2",
  style: {"width":"75%"}
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle",
  style: {"margin-top":"20px"}
}, "商品信息", -1))
const _hoisted_73 = { style: {"border-top":"1px solid #f0f0f0"} }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "商品名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "规格/型号"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "数量"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "单价（元）"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "金额（元）")
], -1))
const _hoisted_75 = { class: "item item2 goods_name" }
const _hoisted_76 = { class: "item item2" }
const _hoisted_77 = { class: "item item2" }
const _hoisted_78 = { class: "item item2" }
const _hoisted_79 = { class: "item item2" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle",
  style: {"margin-top":"20px"}
}, "清分信息", -1))
const _hoisted_81 = { style: {"border-top":"1px solid #f0f0f0"} }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "商户名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "商户号"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "分账金额")
], -1))
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { class: "item item2" }
const _hoisted_85 = { class: "item item2" }
const _hoisted_86 = { class: "item item2" }
const _hoisted_87 = { key: 1 }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "无"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "无"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "无")
], -1))
const _hoisted_89 = [
  _hoisted_88
]
const _hoisted_90 = /*#__PURE__*/_createTextVNode("打印")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _directive_print = _resolveDirective("print")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "订单列表" }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_a_form, { layout: "inline" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "商家名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入",
                  value: _ctx.searches.shop_name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.shop_name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "商品名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入",
                  value: _ctx.searches.goods_name,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searches.goods_name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.OnSearch
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, { onClick: _ctx.OnReset }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_tabs, {
          activeKey: _ctx.searches.type,
          "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searches.type) = $event)),
          onChange: _ctx.callback,
          style: {"margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeData, (item) => {
              return (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: item.type,
                tab: item.title +'('+ item.count +')'
              }, null, 8, ["tab"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["activeKey", "onChange"]),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: _ctx.columns,
          loading: _ctx.loading,
          bordered: "",
          pagination: _ctx.pagination,
          onChange: _ctx.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'orderId')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _hoisted_5,
                    _createElementVNode("span", null, _toDisplayString(record.id), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_6,
                    _createElementVNode("span", null, _toDisplayString(record.order_sn), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_7,
                    _createElementVNode("span", null, _toDisplayString(record.order_type_text), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_8,
                    _createElementVNode("span", null, _toDisplayString(record.create_time), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_9,
                    _createElementVNode("span", null, _toDisplayString(record.order_source_text), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (column.key === 'shop' && record.shop)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("img", {
                    src: record.shop.logo,
                    style: {"width":"50px","height":"50px","position":"absolute","margin-top":"10px"}
                  }, null, 8, _hoisted_10),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, [
                      _hoisted_12,
                      _createElementVNode("span", null, _toDisplayString(record.shop.name), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_13,
                      _createElementVNode("span", null, _toDisplayString(record.shop.id), 1)
                    ]),
                    _createVNode(_component_a_tag, { color: "blue" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(record.shop.type_desc), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'orderMoney')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    _hoisted_15,
                    _createElementVNode("span", null, _toDisplayString(record.distribution_money), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_16,
                    _createElementVNode("span", null, _toDisplayString(record.total_amount), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_17,
                    _createElementVNode("span", null, _toDisplayString(record.discount_amount), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_18,
                    _createElementVNode("span", null, _toDisplayString(record.goods_price), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (column.key === 'member' && record.user !== null )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("img", {
                    src: record.user.avatar,
                    style: {"width":"50px","height":"50px","position":"absolute","margin-top":"10px"}
                  }, null, 8, _hoisted_19),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", null, [
                      _hoisted_21,
                      _createElementVNode("span", null, _toDisplayString(record.user.sn), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_22,
                      _createElementVNode("span", null, _toDisplayString(record.user.nickname), 1)
                    ]),
                    _createVNode(_component_a_tag, { color: "blue" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(record.user.mobile), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'information')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(record.order_goods, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("img", {
                      src: item.image,
                      style: {"width":"50px","height":"50px","position":"absolute","margin-top":"30px"}
                    }, null, 8, _hoisted_23),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", null, [
                        _hoisted_25,
                        _createElementVNode("span", null, _toDisplayString(item.goods_name), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, _toDisplayString(item.spec_value), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_26,
                        _createElementVNode("span", null, _toDisplayString(item.goods_num), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_27,
                        _createElementVNode("span", null, _toDisplayString(item.goods_price), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_28,
                        _createElementVNode("span", null, _toDisplayString(item.total_pay_price), 1)
                      ])
                    ])
                  ]))
                }), 128))
              : _createCommentVNode("", true),
            (column.key === 'status')
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", null, [
                    _hoisted_30,
                    _createElementVNode("span", null, _toDisplayString(record.order_status_text), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_31,
                    _createElementVNode("span", null, _toDisplayString(record.pay_status_text), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_32,
                    _createElementVNode("span", null, _toDisplayString(record.pay_way_text), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_33,
                    _createElementVNode("span", null, _toDisplayString(record.total_amount), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin-left":"10px"},
                    onClick: ($event: any) => (_ctx.getDetail(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_35
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      title: _ctx.title,
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
      width: "50%",
      footer: null
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.orderData.order_sn), 1),
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.orderData.order_status_text), 1)
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.orderData.shop ? _ctx.orderData.shop.naame : ''), 1),
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.orderData.create_time), 1)
            ]),
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.orderData.pay_way_text), 1),
              _hoisted_52,
              _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.orderData.pay_time), 1)
            ]),
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _createElementVNode("div", _hoisted_56, [
                (_ctx.orderData.delivery_type==0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, "快递配送"))
                  : _createCommentVNode("", true),
                (_ctx.orderData.delivery_type==1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, "上门自提"))
                  : _createCommentVNode("", true),
                (_ctx.orderData.delivery_type==2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, "同城配送"))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_60,
              _createElementVNode("div", _hoisted_61, _toDisplayString(new Date(_ctx.orderData.shipping_time*1000).toLocaleDateString().replace(/\//g, "-") + " " + new Date(_ctx.orderData.shipping_time*1000).toTimeString().substr(0, 8)), 1)
            ])
          ]),
          _hoisted_62,
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _hoisted_65,
              _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.orderData.user.nickname), 1),
              _hoisted_67,
              _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.orderData.user.mobile), 1)
            ]),
            _createElementVNode("div", _hoisted_69, [
              _hoisted_70,
              _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.orderData.delivery_address), 1)
            ])
          ]),
          _hoisted_72,
          _createElementVNode("div", _hoisted_73, [
            _hoisted_74,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderData.order_goods, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"display":"flex"},
                key: index
              }, [
                _createElementVNode("div", _hoisted_75, _toDisplayString(item.goods_name), 1),
                _createElementVNode("div", _hoisted_76, _toDisplayString(item.spec_value), 1),
                _createElementVNode("div", _hoisted_77, _toDisplayString(item.goods_num), 1),
                _createElementVNode("div", _hoisted_78, _toDisplayString(item.goods_price), 1),
                _createElementVNode("div", _hoisted_79, _toDisplayString(item.total_pay_price), 1)
              ]))
            }), 128))
          ]),
          _hoisted_80,
          _createElementVNode("div", _hoisted_81, [
            _hoisted_82,
            (_ctx.orderData.sortinginformation.length>0 && _ctx.orderData.sortinginformation)
              ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderData.sortinginformation, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      style: {"display":"flex"},
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_84, _toDisplayString(item.mchName), 1),
                      _createElementVNode("div", _hoisted_85, _toDisplayString(item.mid), 1),
                      _createElementVNode("div", _hoisted_86, _toDisplayString(item.totalAmount), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.orderData.sortinginformation.length==0 && _ctx.orderData.sortinginformation)
              ? (_openBlock(), _createElementBlock("div", _hoisted_87, _hoisted_89))
              : _createCommentVNode("", true)
          ])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
          type: "primary",
          style: {"width":"20%","margin-left":"40%","margin-top":"30px"}
        }, {
          default: _withCtx(() => [
            _hoisted_90
          ]),
          _: 1
        })), [
          [_directive_print, '#printMe']
        ])
      ]),
      _: 1
    }, 8, ["title", "visible"])
  ]))
}